import { render, staticRenderFns } from "./useIndex.vue?vue&type=template&id=2118e3ff&scoped=true"
import script from "./useIndex.vue?vue&type=script&lang=js"
export * from "./useIndex.vue?vue&type=script&lang=js"
import style0 from "./useIndex.vue?vue&type=style&index=0&id=2118e3ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2118e3ff",
  null
  
)

export default component.exports